import { useFormatDate } from '@ben/common/date';
import RiInformationFill from '@ben/icons/information-fill';
import RIcon from '@ben/orion/remix-icon';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import { useTranslation } from 'react-i18next';
import styled, { css, useTheme } from 'styled-components';

interface WindowInfoProps {
  startDate: string;
  endDate: string;
}

const WindowInfo = ({ startDate, endDate }: WindowInfoProps) => {
  const theme = useTheme();
  const formatDate = useFormatDate();
  const { t } = useTranslation();

  return (
    <InfoContainer>
      <RIcon icon={RiInformationFill} color={theme.palette.primary.main} />
      <Typography variant={TypographyVariant.bodySm2}>
        {t('benefit.windowMessage', {
          startDate: formatDate(startDate),
          endDate: formatDate(endDate),
        })}
      </Typography>
    </InfoContainer>
  );
};

export default WindowInfo;

const InfoContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(0.5)};
    width: 100%;
    align-items: center;
  `}
`;
